import { render } from "./TelegramIntegrationView.vue?vue&type=template&id=41f0b2c4&scoped=true"
import script from "./TelegramIntegrationView.vue?vue&type=script&lang=js"
export * from "./TelegramIntegrationView.vue?vue&type=script&lang=js"

import "./TelegramIntegrationView.vue?vue&type=style&index=0&id=41f0b2c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f0b2c4"]])

export default __exports__